import React from "react";
import useTwitch from "../../hooks/useTwitch.js";
import Stack from "../Stack/Stack.js";

import "./RequiresViewerLink.scss";

const RequiresViewerLink = ({ children, message }) => {
  const { actions, isLinked } = useTwitch();

  if (isLinked) {
    return children;
  }

  const [, ...sections] = /(.*)({.*})(.*)/g.exec(message);
  const cta = (
    <div className="requires-viewer-link-cta">
      {sections.filter(Boolean).map((section) => {
        if (section.startsWith("{")) {
          return (
            <button onClick={actions.requestIdShare}>
              {section.replace(/[{}]/g, "")}
            </button>
          );
        }

        return section;
      })}
    </div>
  );

  const childrenWithDisabledProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { disabled: true });
    }

    return child;
  });

  return cta;

  return (
    <Stack vertical spacing="extra-small">
      {childrenWithDisabledProps}
      <div>{cta}</div>
    </Stack>
  );
};

export default RequiresViewerLink;
